import { createBrowserRouter } from "react-router-dom";
import { routeTree } from "./route-tree";

export const router = createBrowserRouter(routeTree);
